import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import i18n from './lang';
import ElementUI from 'element-ui';
import VueI18n from 'vue-i18n';
import 'element-ui/lib/theme-chalk/index.css';
import {initMenu} from "./utils/menus";
import 'font-awesome/css/font-awesome.min.css';
import * as echarts from 'echarts';

// 封装请求为全局调用
import {getRequest} from './utils/api.js';
import {postRequest} from './utils/api.js';
import {postKeyValueRequest} from './utils/api.js';
import {postFormRequest} from './utils/api.js';
import {postFormRequest1} from './utils/api.js';
import {putRequest} from './utils/api.js';
import {deleteRequest} from './utils/api.js';
Vue.prototype.getRequest = getRequest;
Vue.prototype.postRequest = postRequest;
Vue.prototype.postKeyValueRequest = postKeyValueRequest;
Vue.prototype.postFormRequest = postFormRequest;
Vue.prototype.postFormRequest1 = postFormRequest1;
Vue.prototype.putRequest = putRequest;
Vue.prototype.deleteRequest = deleteRequest;
Vue.prototype.$echarts = echarts;


Vue.config.productionTip = false

Vue.use(ElementUI);
Vue.use(VueI18n);

router.beforeEach((to, from,next)=>{
	console.log(to)
	console.log(from)
	if(to.path === '/' || to.path === '/guide' || to.path === '/login'){
		next();
	} else {
		initMenu(router, store);
		next();
	}
});


new Vue({
  router,
  store,
	i18n,
  render: h => h(App)
}).$mount('#app')
